import { useState } from 'react';
import { Link } from 'react-router-dom';
import { X, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function DemoBanner() {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(() => {
    return sessionStorage.getItem('demo-banner-dismissed') === 'true';
  });

  if (dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem('demo-banner-dismissed', 'true');
    setDismissed(true);
  };

  return (
    <div className="sticky top-0 z-50 bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-2 shadow-md">
      <div className="flex items-center justify-between gap-3">
        <div className="flex-1 min-w-0 text-center">
          <span className="font-semibold text-sm md:text-base">{t('demo.banner')}</span>
          <span className="hidden sm:inline text-white/80 text-sm ml-2">— {t('demo.bannerSubtext')}</span>
          <Link
            to="/pricing"
            className="ml-3 inline-flex items-center px-3 py-1 rounded-full bg-white/20 hover:bg-white/30 text-white text-xs font-medium transition-colors"
          >
            {t('demo.register')} →
          </Link>
        </div>
        <button
          onClick={handleDismiss}
          className="shrink-0 p-1 rounded-full hover:bg-white/20 transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex items-center justify-center gap-1.5 mt-1 text-white/70 text-[11px]">
        <Globe className="w-3 h-3" />
        <span>{t('demo.multilingualNote')}</span>
      </div>
    </div>
  );
}
